<template>
   <el-card>
        <el-table ref="table" :data="list" class="history_table" v-loading="is_loading" :row-class-name="tableRowClassName" tooltip-effect="dark">
            <el-table-column label="序号" width="50" type="index"></el-table-column>
            <el-table-column label="企业名称" width="200">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.companyName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="主车号" width="90">
                <template slot-scope="scope">
                    <span class="success_text">{{scope.row.plateNumber}}</span>
                </template>
            </el-table-column>
            <el-table-column label="挂车号" width="100">
                <template slot-scope="scope">
                    {{scope.row.carriageNumber}}
                </template>
            </el-table-column>
            <el-table-column label="驾驶员" width="100">
                <template slot-scope="scope">
                   <span>{{scope.row.driverName}}</span>
                </template>
            </el-table-column>
                <el-table-column label="驾驶员电话" width="120" >
                    <template slot-scope="scope">
                        <span class="success_text">{{scope.row.driverMobile}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计划单状态" width="120">
                    <template slot-scope="scope">
                        <el-tag>{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="打卡时间">
                    <template slot-scope="scope">
                        <span class="warning_text">{{scope.row.punchTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="登记时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.registerTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="安检时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.checkTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="110">
                    <template slot-scope="scope">
                        <span class="getTop success_text" @click="getTop(scope.row)">置顶</span>
                    </template>
                </el-table-column>
        </el-table>
   </el-card>
</template>


<script>
import request from '@/utils/request'

export default {
    data(){
        return{
            is_loading:false,
            list:[]
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            this.is_loading=true;
           request.post('/order/sort_list',{}).then(res=>{
               if(res.code==200){
                   this.list=res.data
                   this.is_loading=false;
               }
           })
        },
        tableRowClassName({row,rowIndex}){
            row.index=rowIndex;
            if(row.status == 30){
                return "success-row";
            }else if(row.status == 90){
                return "warning-row";
            }else {
                return "danger-row";
            }
        },
         statusType(n){
            if(n < 10){
                return "warning";
            }else if(n >= 10 && n < 20){
                return "primary";
            }else if(n >= 20 && n <=30){
                return "success";
            }else {
                return "danger";
            }
        },
        parseStatus(num) {
            switch (num) {
            case 0:
                return "待审核";
            case 10:
                return "已审核"; //待打卡
            case 15:
                return "已打卡"; //待登记
            case 16:
                return "已登记"; //待入场安检
            case 21:
                return "入厂安检"; //待一次过磅
            case 23:
                return "一次过磅";//待充装
            case 24:
                return "已充装"; //待出厂安检
            case 26:
                return "出厂安检"; //待二次过磅
            case 27:
                return "二次过磅"; //待打印
            case 30:
                return "已完成"; //已打印
            case 90:
                return "客户取消";
            case 91:
                return "液厂取消";
            case 92:
                return "已过期";
            }
        },
        getTop(i){
            let retunTop=this.list[i.index];
            this.list.splice(i.index,1);
            this.list.unshift(retunTop)
            let id=i.id;
            request.post('/order/sort/top',{orderId:id}).then(res=>{
                if(res.code!==200){
                    this.$message.error('置顶失败')
                }
            })

        }
    }
}
</script>

<style scoped lang="scss">
.getTop{
    cursor: pointer;
}

</style>